export default __webpack_public_path__ + "static/media/login.f35fe23e.jpg";